(() => {
  if (window.__gustaCartStatusLabelsInitialized) return;
  window.__gustaCartStatusLabelsInitialized = true;

  const selector = [
    '.mini-cart__property.gusta-pickup-only__line-status',
    '.mini-cart__property.gusta-preorder__line-status',
    '.line-item__property.gusta-pickup-only__line-status',
    '.line-item__property.gusta-preorder__line-status'
  ].join(',');

  const updateStatusLabels = () => {
    document.querySelectorAll(selector).forEach((element) => {
      const text = element.textContent.trim();
      const separatorIndex = text.indexOf(':');

      if (separatorIndex === -1) return;

      element.textContent = text.slice(separatorIndex + 1).trim();
    });
  };

  let updateQueued = false;

  const scheduleStatusLabelUpdate = () => {
    if (updateQueued) return;

    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateStatusLabels();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleStatusLabelUpdate, { once: true });
  } else {
    scheduleStatusLabelUpdate();
  }

  new MutationObserver(scheduleStatusLabelUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
